import React from "react";
import { HelpCircle } from "lucide-react";

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@/Components/ui";
import { GROUP_RESERVATION_GUIDE_SECTIONS } from "../groupReservationAdmin.mjs";

type GroupReservationGuideModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function GroupReservationGuideModal({ isOpen, onClose }: GroupReservationGuideModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} centered size="3xl" variant="dialog" scrollable>
      <ModalHeader toggle={onClose}>
        <span className="d-flex align-items-center gap-2">
          <HelpCircle size={18} />
          단체예약 사용 안내
        </span>
      </ModalHeader>
      <ModalBody>
        <div className="d-grid gap-4">
          {GROUP_RESERVATION_GUIDE_SECTIONS.map((section, sectionIndex) => (
            <section key={section.title}>
              <h6 className="mb-2 fw-semibold">
                {sectionIndex + 1}. {section.title}
              </h6>
              <ol className="mb-0 ps-3">
                {section.items.map((item) => (
                  <li key={item} className="mb-2 text-muted">
                    {item}
                  </li>
                ))}
              </ol>
            </section>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          닫기
        </Button>
      </ModalFooter>
    </Modal>
  );
}
